import Nullstack from 'nullstack';
export default function IconLetterK({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-letter-k",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "4",
    x2: "7",
    y2: "20"
  }), "   ", Nullstack.element("path", {
    d: "M7 12h2l8 -8"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "12",
    x2: "17",
    y2: "20"
  }), " ");
}